import React from "react";
import { ElementsPreview } from "./ElementsPreview";
import { Breakpoint, ElementType, ButtonDesignSize, ImageSize } from "../../../shared/types";
export const ElementPreview = ({
  element,
  type,
  text,
  sectionId,
  sectionValueId,
  breakpoint,
  wuiltContext,
  gridContainerWidth
}) => {
  const layout = element?.layout[breakpoint];
  const Component = ElementsPreview[type];
  const horizontalAlignment = element?.layout[breakpoint]?.alignment?.horizontal;
  const verticalAlignment = element?.layout[breakpoint]?.alignment?.vertical;
  const shouldImageFill = element?.settings?.design?.size === ImageSize.Cover;
  const shouldButtonFill = element?.settings?.design?.size === ButtonDesignSize.Fill;
  const isMobileNotUpdated = breakpoint === Breakpoint.Mobile && !element?.layout?.mobile?.isUpdated;
  return /*#__PURE__*/React.createElement("div", {
    style: {
      position: "absolute",
      zIndex: layout?.zIndex,
      top: `${layout?.offset?.top}px`,
      left: isMobileNotUpdated ? "unset" : `${layout?.offset?.left / 100 * gridContainerWidth}px`,
      width: `${layout?.size?.width / 100 * gridContainerWidth}px`,
      height: `${layout?.size?.height}px`,
      minWidth: isMobileNotUpdated ? "100%" : undefined,
      margin: isMobileNotUpdated ? "0 auto" : undefined

      // position: pinSettings?.position ? "sticky" : "absolute",
      // top: isMiddlePosition
      //   ? "50%"
      //   : isTopPosition
      //   ? pinSettings?.offset + "px"
      //   : "unset",
      // bottom:
      //   pinSettings?.position === "bottom"
      //     ? pinSettings?.offset + "px"
      //     : "unset",
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      width: "100%",
      height: "100%",
      display: "flex",
      justifyContent: horizontalAlignment ?? "center",
      alignItems: verticalAlignment ?? "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      wordBreak: "break-word",
      width: element?.type === ElementType.Text || element?.type === ElementType.Counter || element?.type === ElementType.SocialLinks || element?.type === ElementType.AppStoreButton || element?.type === ElementType.Button && !shouldButtonFill || element?.type === ElementType.Image && !shouldImageFill ? "fit-content" : "100%",
      height: element?.type === ElementType.Video || element?.type === ElementType.Image || element?.type === ElementType.Button ? element?.type === ElementType.Button && !shouldButtonFill || element?.type === ElementType.Image && !shouldImageFill ? "fit-content" : "100%" : undefined
    }
  }, /*#__PURE__*/React.createElement(Component, {
    text: text,
    element: element,
    elementSize: {
      ...layout?.size,
      width: (layout?.size?.width ?? 10) / 100 * gridContainerWidth
    },
    sectionId: sectionId,
    sectionValueId: sectionValueId,
    wuiltContext: wuiltContext
  }))));
};
//# sourceMappingURL=ElementPreview.js.map